export default __webpack_public_path__ + "08b7e749efb6f9fee1ee08cc0dc4aeba.png";